export const COLUMNS_ENUM = Object.freeze({
  AUTONOMOUS_SYSTEM: { order: 0, name: "Number" },
  DATA_SOURCES_NUMBER: {
    order: 1,
    name: "Data Sources (#)",
  },
  DATA_SOURCES_PERCENTAGE: { order: 2, name: "Data Sources (%)" },
});
